/**
 * @generated SignedSource<<53a663acd8ac46bbeef6b40523eab40a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutCreditCardList_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutCreditCard_viewer">;
  readonly " $fragmentType": "CheckoutCreditCardList_viewer";
};
export type CheckoutCreditCardList_viewer$key = {
  readonly " $data"?: CheckoutCreditCardList_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutCreditCardList_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutCreditCardList_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutCreditCard_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "01f24945cd59610e6ebb2fa1caa1a843";

export default node;
